
  import { mapGetters } from "vuex"
  import IconBase from "./IconBase.vue"
  import IconLogoAeqNoir from "./icons/IconLogoAeqNoir.vue"
  import AddCredits from "~/components/accounting/AddCredits.vue"

  export default {
    name: `DrawerMenu`,
    components: {
      AddCredits,
      IconBase,
      IconLogoAeqNoir
    },
    props: {
      value: {
        type: Array,
        default: undefined
      }
    },
    data() {
      return {
        title: `Aequivalent`,
        copyright: false,
        miniVariant: false,
        websiteUrl: this.$config.public.websiteUrl,
        drawerStatus: false,
        v3BetaToggle: false
      }
    },
    watch: {
      storedDrawerStatus(newVal) {
        this.drawerStatus = newVal
      },
      isMobile(newVal) {
        this.$store.commit(`drawerMenu/setDrawerStatus`, !newVal)
      }
    },
    computed: {
      ...mapGetters({
        innerValue: `menu/getItems`,
        isExternal: `permissions/userIsExternal`,
        userIsMaster: `permissions/userIsMaster`,
        currentCompanyCredits: `accounting/credits`,
        isGuest: `permissions/userIsGuest`,
        drawerDisplayed: `drawerMenu/getDisplayed`,
        storedDrawerStatus: `drawerMenu/getDrawerStatus`,
        showNuxt3: `companies/getAllowNuxt3`
      }),
      currentPath() {
        return this.$route.path
      },
      currentLanguage() {
        const listContactlanguages = [`fr`, `de`]
        return listContactlanguages.includes(this.$i18n.locale) ? `${this.$i18n.locale}/` : ``
      },
      isMobile() {
        const value = this.$vuetify.breakpoint.mdAndDown
        return value
      },
      alwaysOpen() {
        return this.$vuetify.breakpoint.lgAndUp
      }
    },
    mounted() {
      if (this.isMobile) {
        this.updateDrawerStatus(false)
      }
      if (this.value !== undefined && Array.isArray(this.value)) {
        this.$store.commit(`menu/setItems`, this.value)
      }
    },
    methods: {
      updateDrawerStatus(value) {
        this.$store.commit(`drawerMenu/setDrawerStatus`, value)
      },
      closeDrawerMenu() {
        this.$store.commit(`drawerMenu/closeDrawer`)
      },
      async toggleV3Beta(value) {
        this.v3BetaToggle = false
        if (!value) {
          return
        }

        await this.$api.auth.setNuxt("NUXT3")
        if (process.client && typeof window !== `undefined`) {
          window.location.assign(`/v3/client`)
          return
        }
        this.$router.push({ path: `/v3/client` })
      },
      async swapLang(lang) {
        this.$i18n.setLocale(lang)
        if (this.$auth.loggedIn) {
          await this.$api.userInfo.update({ lang }).then(() => {
            // Reload App
            this.$router.go()
          })
        }
      },
      clickButton(index, subIndex) {
        const item = this.innerValue?.[index]
        if (!!item.to) {
          if (subIndex !== undefined) {
            const subItem = item.items?.[subIndex]
            !!subItem.to && this.$router.push({ path: subItem.to })
          } else {
            this.$store.commit(`menu/setMenuState`, { idx: index, state: { value: true } })
            this.$router.push({ path: this.innerValue[index].to })
          }
        }
      },
      isActive(item) {
        const { to, alternativePath, items } = item
        const path = this.currentPath
        let regex = null
        let parentOpened = false
        if (alternativePath !== undefined) {
          regex = new RegExp(alternativePath, `i`)
        }
        if (items?.length) {
          parentOpened = Boolean(items.filter((item) => item.to === path.replace(/\/$/, ``)).length)
        }
        return to === path.replace(/\/$/, ``) || (alternativePath !== undefined && regex.test(path)) || parentOpened
      },
      defineToggleSubMenu() {
        return 0
      },
      formattedCredits(value) {
        return new Intl.NumberFormat(`fr-CH`, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value)
      }
    }
  }
